import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  model,
  OnInit,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TableModule } from 'primeng/table';
import { Contract } from '@vonq/hapi-elements-types';
import { ContractsAdapter } from '../../adapters/contracts.adapter';
import { MultipostingProvider } from '../../enums/multiposting-provider.enum';
import { PlatformIdAndProvider } from '../../interfaces/job-platform';
import { VonqContractsService } from '../../services/vonq-contracts.service';
import { VonqElementsService } from '../../services/vonq-elements.service';

@Component({
  selector: 'app-contract-selector',
  imports: [TranslocoPipe, TableModule],
  templateUrl: './contract-selector.component.html',
  styleUrl: './contract-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractSelectorComponent implements OnInit {
  vonqElementsService = inject(VonqElementsService);
  vonqContractsService = inject(VonqContractsService);
  selectedContracts = model<Contract[]>([]);
  contractsAdapter = inject(ContractsAdapter);

  ngOnInit(): void {
    void this.vonqElementsService.ensureInitialized();
  }

  mappedSelectedContracts = computed((): PlatformIdAndProvider[] => {
    return this.selectedContracts().map((c) => ({
      id: c.product.product_id,
      provider: MultipostingProvider.VONQ,
      contractId: c.contract_id,
    }));
  });

  onContractSelectionChange(contract: Contract) {
    if (this.selectedContracts().includes(contract)) {
      this.selectedContracts.set(this.selectedContracts().filter((c) => c.contract_id !== contract.contract_id));
    } else {
      this.selectedContracts.set([...this.selectedContracts(), contract]);
    }
  }
}
